import type { JSX } from 'react';
import React from 'react';

import { Color } from '@/constants/color';
import { Props } from '@/ui/components/ColorCircle/types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const ColorCircle = ({ color }: Props): JSX.Element => {
  let colorClass = '';
  switch (color) {
    case Color.AMBER:
      colorClass = 'bg-amber-500';
      break;
    case Color.BLACK:
      colorClass = 'bg-black';
      break;
    case Color.BLUE:
      colorClass = 'bg-blue-500';
      break;
    case Color.CYAN:
      colorClass = 'bg-cyan-500';
      break;
    case Color.EMERALD:
      colorClass = 'bg-emerald-500';
      break;
    case Color.GRAY:
      colorClass = 'bg-gray-500';
      break;
    case Color.GREEN:
      colorClass = 'bg-green-500';
      break;
    case Color.INDIGO:
      colorClass = 'bg-indigo-500';
      break;
    case Color.LIME:
      colorClass = 'bg-lime-500';
      break;
    case Color.NEUTRAL:
      colorClass = 'bg-neutral-500';
      break;
    case Color.ORANGE:
      colorClass = 'bg-orange-500';
      break;
    case Color.RED:
      colorClass = 'bg-red-500';
      break;
    case Color.SKY:
      colorClass = 'bg-sky-500';
      break;
    case Color.SLATE:
      colorClass = 'bg-slate-500';
      break;
    case Color.STONE:
      colorClass = 'bg-stone-500';
      break;
    case Color.TEAL:
      colorClass = 'bg-teal-500';
      break;
    case Color.WHITE:
      colorClass = 'bg-white';
      break;
    case Color.YELLOW:
      colorClass = 'bg-yellow-500';
      break;
    case Color.ZINC:
      colorClass = 'bg-zinc-500';
      break;
  }

  return <div className={`${colorClass} h-2 w-2 rounded-full mr-1`} />;
};

export default ColorCircle;
